import { Directive, Input, OnChanges, SimpleChanges, ElementRef, Renderer2, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[directive-collapse]', /* [data-directive="collapse"] */
})
export class CollapseDirective implements OnChanges, OnInit, AfterViewInit {
    @Input() public collapsed: any = null;
    private _init: boolean = false;
    private _elem: HTMLElement;
    private _isCollapsed: boolean = false;
    private _isAnimating: boolean = false;
    private _timeout: number = 500;

    @Output() public onCollapsed: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private _elementRef: ElementRef,
        private _renderer2: Renderer2,
    ) { }

    ngOnInit(): void {
        this._elem = this._elementRef.nativeElement;

    }

    ngAfterViewInit(): void {
        if (this.collapsed) {
            this._renderer2.setStyle(this._elem, 'overflow', 'hidden');
            this._renderer2.setStyle(this._elem, 'height', '0px');
            this._isCollapsed = true;
            this._isAnimating = false;
        }

        setTimeout(() => {

            this._init = true;
            this._handleChange();
        }, 0);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this._handleChange();
    }

    private _handleChange(): void {
        if (!this._init) {
            return;
        }

        const shouldCollapse: boolean = !this._isCollapsed && this.collapsed && this._isAnimating === false;
        const shouldExpand: boolean = this._isCollapsed && !this.collapsed && this._isAnimating === false;

        let expandedHeight: number;
        if (shouldCollapse) {
            expandedHeight = this._elem.clientHeight;
            this._renderer2.setStyle(this._elem, 'height', `${expandedHeight}px`);
            this._renderer2.setStyle(this._elem, 'overflow', 'hidden');
            this._renderer2.setStyle(this._elem, 'opacity', '1');
            this._renderer2.setStyle(this._elem, 'transition', 'all .5s ease');

            this._isAnimating = true;

            setTimeout(() => {
                this._renderer2.setStyle(this._elem, 'opacity', '0');
                this._renderer2.setStyle(this._elem, 'height', '0px');
                setTimeout(() => {
                    this._isCollapsed = true;
                    this._isAnimating = false;
                    this.onCollapsed.emit(this._isCollapsed);
                }, this._timeout);
            }, 0);
        }

        if (shouldExpand) {
            this._renderer2.setStyle(this._elem, 'transition', 'none');
            this._renderer2.setStyle(this._elem, 'height', 'auto');
            expandedHeight = this._elem.clientHeight;
            this._renderer2.setStyle(this._elem, 'height', '0px');
            this._renderer2.setStyle(this._elem, 'transition', 'all .5s ease');

            this._isAnimating = true;

            setTimeout(() => {
                this._renderer2.setStyle(this._elem, 'opacity', '1');
                this._renderer2.setStyle(this._elem, 'height', `${expandedHeight}px`);
                setTimeout(() => {
                    this._renderer2.setStyle(this._elem, 'overflow', null);
                    this._renderer2.setStyle(this._elem, 'height', null);
                    this._isCollapsed = false;
                    this._isAnimating = false;
                    this.onCollapsed.emit(this._isCollapsed);
                }, this._timeout);
            }, 0);
        }
    }
}
